"use client";

import { motion } from "framer-motion";
import { useRef, type ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Aceternity-inspired spotlight card. A soft green glow tracks the cursor
 * across the surface (CSS `.spot` reads the --sx/--sy variables we set here),
 * combined with the tactile hover-lift spring. Gives the flat glass panels a
 * sense of a light source reacting to touch.
 */
export function SpotlightCard({
  children,
  className,
  index = 0,
  style,
}: {
  children: ReactNode;
  className?: string;
  index?: number;
  style?: React.CSSProperties;
}) {
  const ref = useRef<HTMLDivElement>(null);

  const onMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty("--sx", `${e.clientX - r.left}px`);
    el.style.setProperty("--sy", `${e.clientY - r.top}px`);
  };

  return (
    <motion.div
      ref={ref}
      onMouseMove={onMove}
      whileHover={{ scale: 1.02, y: -4 }}
      transition={{ type: "spring", stiffness: 260, damping: 18, delay: index * 0.02 }}
      className={cn("spot glass neo", className)}
      style={style}
    >
      {children}
    </motion.div>
  );
}
